/**
 * Tax Master (HSN -> GST rate) constants.
 */

export const TAX_MASTER_PAGE_SIZE = 10;

/** Allowed GST slabs per Tax Master spec — supersedes the old item-level 5/12/18 set. */
export const GST_RATE_OPTIONS = [
  { value: 0,  label: '0%' },
  { value: 5,  label: '5%' },
  { value: 12, label: '12%' },
  { value: 18, label: '18%' },
  { value: 28, label: '28%' },
];

export const GST_RATE_VALUES = GST_RATE_OPTIONS.map((o) => o.value);

/** Coerce API / form values to a select option, or '' when not a known slab */
export function normalizeGstRateForSelect(value) {
  if (value === '' || value == null) return '';
  const n = Number(value);
  if (!Number.isFinite(n)) return '';
  return GST_RATE_VALUES.includes(n) ? n : '';
}

/** Same value set as ITEM_TYPES/CATEGORY_TYPES, kept local to avoid a circular import with constants/index.js. */
export const TAX_CATEGORY_OPTIONS = [
  'MEDICINE', 'CONSUMABLE', 'SURGICAL', 'IMPLANT',
  'ASSET', 'EQUIPMENT', 'REAGENT', 'LINEN', 'GENERAL', 'OTHER',
].map((t) => ({ value: t, label: t }));
